module.exports = __webpack_public_path__ + "r-v3/img/ml_12_01_over.651169c5.jpg";